module.exports = __webpack_public_path__ + "static/media/Cloudy.5e13329c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/weather/Cloudy.svg
// module id = 402
// module chunks = 0